import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import customAPI from "./customAPI"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { linksUrl } from "../constants/enum"

export const useGet = ({ url, queryKey }) => {
  const { token } = useSelector((state) => state.auth)

  const { isLoading, data, isError } = useQuery({
    queryKey: [queryKey],
    queryFn: async () => {
      const { data } = await customAPI.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      return data.data
    },
  })
  return { isLoading, isError, data }
}

export const usePost = ({
  queryKey,
  url,
  resetValues = () => {},
  successMessage = "",
  onSuccessTasks = () => {},
}) => {
  const { token } = useSelector((state) => state.auth)
const navi = useNavigate();

  const queryClient = useQueryClient()
  const { mutate, isPending, isError, data, isSuccess } = useMutation({
    mutationFn: async ({ data: newData }) => {
      const { data } = await customAPI.post(url, newData, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      return data.data
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [queryKey] })
      if (successMessage) {
        toast.success(successMessage)
      }
      resetValues()
      onSuccessTasks(data)
    },
    onError: (error) => {
      toast.error(error.response.data.message, {
        position: "top-center",
        onClose: () => navi(linksUrl.login)
      })
    },
  })
  return { isPending, mutate, isError, data, isSuccess }
}

export const useFetchWithBody = ({
  url,
  queryKey,
  inputData,
  manipulateData = false,
  manipulateDataFn = () => {},
}) => {
  const { token } = useSelector((state) => state.auth)
  const { isLoading, data, isError, isFetching } = useQuery({
    queryKey: [queryKey],
    queryFn: async () => {
      const { data } = await customAPI.post(url, inputData, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      let newData = data.data
      if (manipulateData) {
        newData = manipulateDataFn(newData)
      }
      return newData
    },
  })
  return { isLoading, isError, data, isFetching }
}
